export default __webpack_public_path__ + "static/media/Software-Downloading-img1.7b5056cf.png";